<template>
    <div>
        <a-modal v-model="visible" :title="$t('pdf')" :maskClosable="false" :okText="$t('print')"
            :cancelText="$t('cancel')" :cancelButtonProps="{ class: 'btn ts-whitespace-no-wrap btn-default' }"
            :confirmLoading="waiting" :footer="null" :zIndex="2000" :width="'100vw'"
            :bodyStyle="{ height: '100vh', padding: 0 }" wrapClassName="fullscreen-modal" @cancel="onCancel">
            <div id="container">
                <i class="fa fa-spinner spin fa-2x text-white" v-if="printing"></i>
                <iframe v-if="!printing" :src="src"></iframe>
            </div>
        </a-modal>
    </div>
</template>
<script>
import { mapActions } from 'vuex'

export default {
    name: 'pdfPreview',
    props: ['value', 'scoreData'],

    data() {
        return {
            show: false,
            waiting: false,
            printing: false,
            src: '',
            model: {}
        }
    },
    created() {
        this.model = this.scoreData
    },
    computed: {
        visible: {
            get() {
                return this.value
            },
            set(val) {
                this.$emit('input', val)
            }
        }
    },
    methods: {
        ...mapActions('studentScoringEntry', ['previewPDF']),

        onCancel() {
            this.src = ''
            this.$emit('cancel', false)
        },
        previewPDF() {            
        this.printing = true
        const payload = {
        class_id: this.model.class_id,
        scoring_cycle_id: this.model.scoring_cycle_id,
        acps_id: this.model.acps_id,
        acp_id: this.model.acp_id,
        ac_year_id:this.model.ac_year_id,
        ac_term_id:this.model.ac_term_id,
        student_id:this.model.student_id
    }
            this.$store
                .dispatch('studentScoringEntry/previewPDF', payload)
                .then(response => {
                    this.printing = false
                    this.src = response.url
                })
                .catch(error => {
                    this.printing = false
                    this.$toasted.error(error.message)
                })
        }

    }
}
</script>

<style scoped>
#container {
    width: 100%;
    height: 100%;
    background: black;
    text-align: center;
}

#container iframe {
    width: 100%;
    height: 100%;
    border: none;
}

#container i {
    margin-top: 40vh;
}

/* make modal fullscreen */
::v-deep(.fullscreen-modal .ant-modal) {
    top: 0 !important;
    padding: 0;
    max-width: 100%;
    height: 100%;
}

::v-deep(.fullscreen-modal .ant-modal-content) {
    height: 100%;
    border-radius: 0;
}
</style>